import styled from "styled-components"

export const ContainerModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 900px;

  height: calc(100vh - 100px);
  overflow-y: scroll;
  padding-right: 6px;

  ::-webkit-scrollbar {
    display: none;
  }

  .actions{
    width: 100%;
    justify-content: space-between;
    max-width: none !important;
    text-align: center !important;
    flex-direction: row-reverse;
    flex: 1;

    button{
        justify-content: center;

    }
  }

  .field{
    margin-top: 15px;

    .input input,
    .input select {
        border-bottom: 1px solid rgba(0,0,0,.1);
    }
  }


  button.buttonClosePreview {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      position: fixed;
      bottom: -40px;
      left: 40%;

      padding: 4px 12px;
      gap: 10px;

      line-height: 1rem;
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      background-color: transparent;
      border: none;

      transition: all 0.35s;
      &:hover {
          transform: scale(1.1);
      }
    }

`;

export const SectionModal = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  background-color: #FFFF;
  border-radius: 5px;
  padding: 2rem 2.2rem;

  > h1 {
    font-size: 1.125rem;
    color: var(--title);
    border: none;
    border-bottom: 1px solid rgba(0,0,0,.1);
  }

  .fieldGroupPonto {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;

    .fieldPonto {
      display: flex;
      flex-direction: column;
      gap: 4px;

      >h3 {
        font-size: 14px;
        font-weight: 500;
        color: var(--font);
      }

      >h4 {
        font-size: 1rem;
        font-weight: 600;
        color: var(--primary);
      }
    }
  }
`;

export const ContainerHeader = styled.header`
    position: fixed;
    z-index: 9;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 80px;

    background-color: #D8BCA9;
    box-shadow: 0px 0px 10px #0000001A;

    > img{
        height: 40px;
        margin-top: 20px;
        margin-left: 20px;
    }

    > .containerAuth{
        position: relative;
        cursor: pointer;
        > h3{
            margin: 20px;
            padding-left: 20px;
            line-height: 40px;
            border-left: 1px solid var(--background);
            font-size: 90%;
        }
        > nav{
            position: absolute;
            right: 0;
            opacity: 0;
            visibility: hidden;

            background-color: #fff;
            box-shadow: 0px 5px 10px #0000001A;
            transition: .2s;

            a, button {
                display: block;
                width: 100%;
                padding: 10px 20px;
                text-align: center;
                text-decoration: none;
                background: transparent;
                border: none;
                color: var(--font);
                transition: .2s;
                &:hover{
                    text-decoration: underline;
                    color: var(--primary);
                }
            }
        }
        &:hover{
            > nav{
                opacity: 1;
                visibility: visible;
            }
        }
    }
`

export const ContainerSidebar = styled.div`
    position: fixed;
    z-index: 8;
    width: 80px;
    padding-top: 80px;
    > nav{
        width: 80px;
        height: calc(100vh - 80px);
        transition: .2s;
        background-color: var(--primary);
        box-shadow: 0px 0px 20px #0000001A;
        
        a, button{
            display: flex;
            width:100%;
            height: 60px;
            background: transparent;
            border: none;
            text-decoration: none;
            border-left: 4px solid var(--primary);
            transition: .1s;
            font-size: 15px;
            .icon{
                display: flex;
                justify-content: center;
                margin-left: -4px;
                opacity: 1;
                min-width: 80px;
                width: 80px;
                padding: 20px 0;
                font-size:20px;
                svg{
                    width: 20px;
                    height: 20px;
                    color: #fff;
                }
            }
            .text{
                visibility: hidden;
                opacity: 0;
                width: 0;
                color: var(--default);
                padding: 20px 0;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                transition: .2s;
                transition-delay: .2s;
            }
            &.active{
                border-color: var(--primary);
                .icon{
                    opacity: 1;
                }
            }
        }
    }

    :hover, &.active{
        > nav{
            width: 260px;
            background-color: #D8BCA9;
            overflow-y: auto;
            overflow-x: hidden;
            a, button{
                border-left: 4px solid var(--primary);
                color: #000000;
                .icon{
                    opacity: 1;
                    svg{
                        color: var(--defalult);
                    }
                }
                .text{
                    visibility: visible;
                    width: auto;
                    opacity: 1;
                }
                &:hover{
                    border-left: 4px solid var(--primary);
                    background-color: #d1a98e;
                    .text{
                        color: var(--default)
                    }
                }
            }
        }
    }
`

export const ContainerLayout = styled.div`
    position: relative;
    display: block;
    > .content{
        display: block;
        padding: 110px 30px 30px 110px;
    }
`